import React from 'react';
import { TypedMemo } from '../../../../../common/types';
import type { CoverRedo } from './useCoverRedo';
import { useCoverRedoDialog } from './useCoverRedoDialog';
import { CoverRedoBanner } from './CoverRedoBanner';
import { CoverRedoDialog } from './CoverRedoDialog';

interface CoverRedoPanelProps {
  accountId: number;
  catalogItemUuid: string;
  redo: CoverRedo;
  /** The largest `etaSec` of the kit assets that are being made now, or null. */
  etaSec?: number | null;
}

/**
 * The banner and the confirm dialog of "Redo the kit with the new cover" (design kit-redo-cover),
 * at the top of the Kit and the Posts tab of a release. The tab owns `useCoverRedo`, so its slots
 * can show "Old cover" from the same answer.
 */
const CoverRedoPanelComponent: React.FC<CoverRedoPanelProps> = ({ accountId, catalogItemUuid, redo, etaSec }) => {
  const dialog = useCoverRedoDialog({ accountId, catalogItemUuid });
  return (
    <>
      <CoverRedoBanner redo={redo} onRedo={dialog.open} etaSec={etaSec} />
      <CoverRedoDialog model={dialog} />
    </>
  );
};

export const CoverRedoPanel = TypedMemo(CoverRedoPanelComponent);
